import React from 'react';

import SSButton from '../SSButton';

import PlayStore from '../../assets/playstore.png';
import AppStore from '../../assets/appstore.png';
import ProCallerIcon from '../../assets/PC-1.svg';
import ProCallerAndroid from '../../assets/pc-icon-android.svg';
import ProEmailerIos from '../../assets/pe-icon-ios.svg';
import ProEmailerAndroid from '../../assets/pe-icon-android.svg';
import './pcinstall.scss';

import { SSPC } from '../../Constants/base';

export default function PCInstall({ setOpenPopUp, plan }) {
  return (
    <div
      className="pc-install"
      // style={{
      //   background:
      //     plan.product.nickName === SSPC ? 'linear-gradient(120.25deg, #018015 -47.82%, #025000 68.42%)' : '#EDEDED',
      // }}
    >
      <div className="les-logo">
        <div className="step-footer">
          <SSButton btnText={'back'} type={'outline'} onClickHandle={() => setOpenPopUp(false)} />
          <SSButton btnText={'finish'} type={'filled'} onClickHandle={() => setOpenPopUp(false)} />
        </div>
        <div className="step-desc">
          <div>
            <h1>Install the mobile app on your Smartphone</h1>
            <p>
              Please use the links below or manually search for
              {plan.product.nickName === SSPC ? <span> Pro Caller </span> : <span> Pro Emailer </span>}
              on your appstore or playstore and install the application on your device.
            </p>
            <div className="download-links apps">
              <div className="browser app">
                <img src={plan.product.nickName === SSPC ? ProCallerIcon : ProEmailerIos} alt="icon" />
                <div className="browser-details">
                  <h1>{plan.product.nickName === SSPC ? <span>Pro Caller iOS</span> : <span>Pro Emailer iOS</span>}</h1>
                  <a
                    className="store-icon"
                    href={
                      plan.product.nickName === SSPC
                        ? 'https://apps.apple.com/us/app/pro-caller/id6444336731'
                        : 'https://apps.apple.com/us/app/pro-emailer/id1662321770?platform=iphone'
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={AppStore} alt="" />{' '}
                  </a>
                </div>
              </div>
              <div className="browser app">
                <img src={plan.product.nickName === SSPC ? ProCallerAndroid : ProEmailerAndroid} alt="icon" />
                <div className="browser-details">
                  <h1>
                    {plan.product.nickName === SSPC ? (
                      <span>Pro Caller Android</span>
                    ) : (
                      <span>Pro Emailer Android</span>
                    )}
                  </h1>
                  <a
                    className="store-icon"
                    href={
                      plan.product.nickName === SSPC
                        ? 'https://play.google.com/store/apps/details?id=com.holofy.procaller'
                        : 'https://play.google.com/store/apps/details?id=com.holofy.proemailer'
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={PlayStore} alt="" />{' '}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
